import { Building2, LogOut, ShieldCheck } from 'lucide-react';
import { Outlet } from 'react-router-dom';

import { NavLink } from '@/components/NavLink';
import { Button } from '@/components/ui/button';
import { ErrorBoundary } from '@/components/shared/ErrorBoundary';
import { SkipToContent } from '@/components/shared/SkipToContent';
import { ROUTES } from '@/config/constants';
import { useAuth } from '@/features/auth/use-auth';

const platformNavItems = [
  {
    title: 'Organizations',
    href: ROUTES.PLATFORM_ORGANIZATIONS,
    icon: Building2,
  },
];

export function PlatformLayout() {
  const { profile, signOut } = useAuth();

  return (
    <>
      <SkipToContent />
      <div className="min-h-screen bg-muted/30">
        <header className="border-b border-border bg-background">
          <div className="mx-auto flex max-w-7xl items-center justify-between gap-4 px-4 py-3 sm:px-6">
            <div className="flex items-center gap-3">
              <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-primary text-primary-foreground">
                <ShieldCheck className="h-5 w-5" />
              </div>
              <div>
                <p className="text-sm font-semibold text-foreground">Platform Console</p>
                <p className="text-xs text-muted-foreground">Client onboarding and lifecycle control</p>
              </div>
            </div>
            <div className="flex items-center gap-3">
              <span className="hidden text-sm text-muted-foreground sm:inline">{profile?.email}</span>
              <Button variant="ghost" size="icon" onClick={signOut} aria-label="Sign out">
                <LogOut className="h-4 w-4" />
              </Button>
            </div>
          </div>
        </header>

        <div className="mx-auto flex max-w-7xl flex-col gap-6 px-4 py-6 sm:px-6 lg:flex-row">
          <aside className="w-full shrink-0 lg:w-64">
            <nav className="rounded-2xl border border-border bg-background p-3">
              <p className="px-3 pb-2 text-xs font-semibold uppercase tracking-wide text-muted-foreground">
                Platform
              </p>
              <div className="space-y-1">
                {platformNavItems.map((item) => (
                  <NavLink
                    key={item.href}
                    to={item.href}
                    end
                    className="flex items-center gap-3 rounded-xl px-3 py-2 text-sm text-muted-foreground transition-colors hover:bg-muted hover:text-foreground"
                    activeClassName="bg-primary text-primary-foreground hover:bg-primary hover:text-primary-foreground"
                  >
                    <item.icon className="h-4 w-4" />
                    <span>{item.title}</span>
                  </NavLink>
                ))}
              </div>
            </nav>
          </aside>

          <main id="main-content" className="min-w-0 flex-1" tabIndex={-1}>
            <ErrorBoundary>
              <Outlet />
            </ErrorBoundary>
          </main>
        </div>
      </div>
    </>
  );
}
